import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpProvider } from 'app/core/common/http-provider.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService extends HttpProvider {
  //#region Variable

  private readonly expenseTransactionEndpoint = '/expense_list_web/';
  private readonly userBalanceEndpoint = '/bank/balance/';
  private readonly userExpenseBucketEndpoint = '/expenses_category_user/';
  private readonly adminDashboardStatsEndpoint = '/admin_dashboard_keystats/';
  private readonly adminYearlyExpenseEndpoint = '/expenses_by_/';
  private readonly adminExpenseBucketEndpoint =
    '/expenses_category_organisation/';
  private readonly teamExpenseBucketEndpoint = '/expenses_category_team/';
  private readonly teamEndpoint = '/team/';
  private readonly teamDetailEndpoint = '/team_detail/';
  private readonly expenseGlobalEndpoint = '/expenses_master_list/';
  private readonly expenseBucketDashboardEndpoint =
    '/expense_bucket_dashboard/';
  private readonly userExpenseBudgetEndpoint = '/user_expense_budget/';
  private readonly poolAccountDataEndpoint = '/organization_pool_balance/';
  private readonly transactionEndpoint = '/transaction/';
  private readonly c2cDataEndpoint = '/money_transfer_customer_to_customer/';
  private readonly expenseBucketStatsEndpoint = '/expense_bucket_stats/';
  private readonly recoverableUnrecoverableAmountEndpoint =
    '/recoverable_unrecoverable_expenses/';
  private readonly refreshTransactionDescEndpoint =
    '/refresh_transaction_comment/';
  private readonly userLimitEndpoint = '/user_credit_limit/';
  private readonly pendingActionStatsEndpoint = '/pending_approval_stat/';
  private readonly pendingActionDataEndpoint = '/pending_approval_detail/';
  private readonly expenseBucketByIdEndpoint = '/expense_bucket/';

  //#endregion

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  //#region User Dashboard Query
  getUserBalance(userid = 0) {
    if (userid != 0) {
      const queryParams = {
        user_id: userid,
      };
      return this.get(this.userBalanceEndpoint, true, {
        params: this.toHttpParams(queryParams),
      });
    } else {
      return this.get(this.userBalanceEndpoint);
    }
  }

  getUnReportedExpense(queryParams) {
    return this.get(this.expenseTransactionEndpoint, false, {
      params: this.toHttpParams(queryParams),
    });
  }

  getExpenseCategoryDataUserWise(fromDate, toDate, userid = 0) {
    if (userid != 0) {
      const queryParams = {
        user_id: userid,
      };
      return this.get(
        this.userExpenseBucketEndpoint + fromDate + '/' + toDate + '/',
        true,
        {
          params: this.toHttpParams(queryParams),
        }
      );
    } else {
      return this.get(
        this.userExpenseBucketEndpoint + fromDate + '/' + toDate + '/',
        true
      );
    }
  }

  //#endregion

  //#region
  getAdminDashboardStats() {
    return this.get(this.adminDashboardStatsEndpoint);
  }

  getExpenseYearWise() {
    return this.get(this.adminYearlyExpenseEndpoint);
  }

  // getAdminExpenseBucketDashboard(){
  //   return this.get(this.expenseBucketDashboardEndPoint);
  // }

  // getExpenseDataAdmin(fromDate, toDate, status) {
  //   const queryParams = {
  //     for_whole_team: 'False',
  //     for_whole_organization: 'True',
  //   };
  //   return this.get(
  //     this.expenseGlobalEndpoint + fromDate + '/' + toDate + '/',
  //     true,
  //     {
  //       params: this.toHttpParams(queryParams),
  //     }
  //   );
  // }

  getExpenseCategoryDataAdminWise(fromDate, toDate) {
    return this.get(
      this.adminExpenseBucketEndpoint + fromDate + '/' + toDate + '/',
      false
    );
  }

  // getExpenseBucketDashboard() {
  //   const queryParams = {
  //     for_user: 'False',
  //   };
  //   return this.get(this.expenseBucketDashboardEndpoint, true, {
  //     params: this.toHttpParams(queryParams),
  //   });
  // }
  //#endregion

  //#region TEAM API
  getTeamForUser() {
    return this.get(this.teamEndpoint);
  }

  getTeamDetails(id) {
    return this.get(this.teamDetailEndpoint + `${id}/`);
  }

  getExpenseCategoryDataTeamWise(
    startOfMonth: any,
    endOfMonth: any,
    selectedTeamId: number
  ) {
    const queryParams = {
      team_id: selectedTeamId,
    };
    return this.get(
      this.teamExpenseBucketEndpoint + startOfMonth + '/' + endOfMonth + '/',
      true,
      {
        params: this.toHttpParams(queryParams),
      }
    );
  }

  getUserBudgetData(id: number) {
    return this.get(this.userExpenseBudgetEndpoint + id + '/');
  }

  setDefaultExpenseBucket(userid, selectedBucket: any) {
    let strURL = '/user/' + userid + '/update_user_expense_bucket/';
    let body = {
      expense_bucket_id: selectedBucket,
    };
    return this.put(strURL, body);
  }
  //#endregion

  getPoolAccountData() {
    return this.get(this.poolAccountDataEndpoint);
  }

  getUserTranscation(type: any, pagingConfig: any) {
    const queryParams = {
      transaction_mode: type,
      page_size: pagingConfig.pageSize,
      page: pagingConfig.pageNumber,
    };
    return this.get(this.transactionEndpoint, false, {
      params: this.toHttpParams(queryParams),
    });
  }

  sendMoneyToTeam(value: any) {
    return this.post(this.c2cDataEndpoint, value);
  }

  // ExpenseBucket Statistics
  getExpenseBucketStats(pagingConfig?: any) {
    const queryParams = {
      page_size: pagingConfig.pageSize,
      page: pagingConfig.pageNumber,
      for_user: 'False',
    };
    return this.get(this.expenseBucketStatsEndpoint, false, {
      params: this.toHttpParams(queryParams),
    });
  }

  getRecoverableUnrecoverable() {
    return this.get(this.recoverableUnrecoverableAmountEndpoint, false);
  }

  updateTransactionDesc(trace_no: number) {
    return this.get(this.refreshTransactionDescEndpoint + `${trace_no}` + '/');
  }

  getUserCreditLimit(id) {
    return this.get(this.userLimitEndpoint + `${id}/`);
  }
  getPendingActionStats(startOfMonthD: string, endOfMonthD: string) {
    return this.get(this.pendingActionStatsEndpoint,false);
  }

  getPendingReportData(startOfMonthD: string, endOfMonthD: string) {
    const queryParams = {
      start_date: startOfMonthD,
      end_date: endOfMonthD,
    };
    return this.get(this.pendingActionDataEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getExpenseBucketById(id:number, role=''){
    const queryParams = {
      role: role
    };
    return this.get(this.expenseBucketByIdEndpoint+`${id}/`, true, {
      params: this.toHttpParams(queryParams),
    });
  }
}
